import { Dropdown, message, Typography } from 'antd';
import LegacyApi, { LARAPI, SettingsAPI } from 'api';
import { HorizontalDotsIcon } from 'assets/icons';

import LaunchDealModal from 'components/Dashboard/LaunchDealModal';
import ReadyLaunchDealModal from 'components/Dashboard/LaunchDealModal/ReadyLaunchDealModal';
import ReadyLaunchModal from 'components/Dashboard/LaunchDealModal/ReadyLaunchModal/ReadyLaunchModal';
import WithdrawModal from 'components/LARDB/Settings/WithdrawModal';
import Modal from 'components/Modals/Modal/Modal';
import { useCallback, useMemo, useReducer, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AgreementReviewModal from '../../../../../../components/AgreementReviewModal';
import DelayArchivePopup from '../../../../../../components/Dashboard/DelayArchivePopup/DelayArchivePopup';
import useLarApi from '../../../../../../components/LarAppNew/hooks/useLarApi';
import NoResults from '../../../../../../components/LarAppNew/Modals/EndScenarioModal/NoResults';
import styles from './Actions.module.css';

export default function Actions({ meta: { status, id, type }, updateData }) {
  const [archiveModalVisible, setArchiveModalVisible] = useState(false);
  const [unarchiveModalVisible, setUnarchiveModalVisible] = useState(false);
  const [launchDealModalVisible, setLaunchDealModalVisible] = useState(false);
  const [readyLaunchModalVisible, setReadyLaunchModalVisible] = useState(false);
  const [readyLaunchDealModalVisible, setReadyLaunchDealModalVisible] = useState(false);
  const [isBeginScenarioOpen, setIsBeginScenarioOpen] = useState(false);
  const [withdrawModalVisible, setWithdrawModalVisible] = useState(false);
  const [isBeginScenarioFailed, toggleIsBeginScenarioFailed] = useReducer((s) => !s, false);
  const [isApproveDealOpen, toggleIsApproveDealOpen] = useReducer((s) => !s, false);
  const [isArchiveDelayOpen, toggleIsArchiveDelayOpen] = useReducer((s) => !s, false);
  const history = useHistory();
  const dispatch = useDispatch();
  const { endLarCreation } = useLarApi();
  const API = useMemo(() => new LARAPI(id), [id]);
  const APISettings = useMemo(() => new SettingsAPI(id), [id]);

  const handleArchive = useCallback(
    ({ reason, additionalInfo }) => {
      API.archive(reason, additionalInfo).then(() => {
        setArchiveModalVisible(false);
        updateData();
      });
    },
    [API, updateData],
  );

  const handleWithdraw = useCallback(
    ({ reason, additionalInfo }) => {
      API.archive(reason, additionalInfo).then(() => {
        setWithdrawModalVisible(false);
        updateData();
      });
    },
    [API, updateData],
  );

  const handleUnarchive = useCallback(() => {
    API.unarchive().then(() => {
      message.success('You successfully restored the deal');
      setUnarchiveModalVisible(false);
      updateData();
    });
  }, [API, updateData]);

  const handleVerifyDeal = useCallback(() => {
    APISettings.postLarScheduleStatus(id).then(() => {
      message.success('You successfully verified deal');
      updateData();
    });
  }, [API, updateData]);

  function handleBeginScenario() {
    endLarCreation({
      id: +id,
    })
      .then((res) => {
        setIsBeginScenarioOpen(false);
        if (res?.response?.data?.error) {
          toggleIsBeginScenarioFailed();
        } else {
          message.success(`You started Scenario #${id}`);
        }
      })
      .catch(() => setIsBeginScenarioOpen(false));
  }

  const handleApprove = () => {
    toggleIsApproveDealOpen();
    endLarCreation({ id: +id })
      .then(() => {
        message.success(`You approved Deal #${id}`);
        updateData();
      })
      .catch(() => message.error('Error'));
  };

  const handleArchiveDelay = () => {
    toggleIsArchiveDelayOpen();
  };
  const postEndCreation = async (type) => {
    try {
      await LegacyApi().post('/LAR/creation/end_creation', { id, type });
      message.success(
        type === 'auction'
          ? 'Auction is ready to be scheduled'
          : 'Scenario launched successfully. Deal moved to Scenario Pipeline',
      );
      updateData();
    } catch (e) {
      console.log(e);
    }
  };
  const handleEndCreation = async (isScenario) => {
    if (isScenario) {
      handleToggleReadyLaunchDeal();
    } else {
      await postEndCreation('auction');
      history.push(`/onboarding/auction/${id}/schedule`);
    }
  };

  const handleToggleBeginScenario = () => setIsBeginScenarioOpen(!isBeginScenarioOpen);

  const handleToggleLaunchDeal = () => setLaunchDealModalVisible((prev) => !prev);
  const handleToggleReadyLaunch = () => setReadyLaunchModalVisible((prev) => !prev);
  const handleToggleReadyLaunchDeal = () => setReadyLaunchDealModalVisible((prev) => !prev);

  const menuItems = useMemo(() => {
    function openSettings() {
      history.push(`/onboarding/lar_db/${id}/settings`);
    }

    function openProfile() {
      history.push(`/onboarding/loan_profile/${id}`);
    }

    function archive() {
      setArchiveModalVisible(true);
    }

    function unarchive() {
      setUnarchiveModalVisible(true);
    }

    function openLaunchDeal() {
      handleToggleLaunchDeal();
    }

    function withdraw() {
      setWithdrawModalVisible(true);
    }

    function viewQuote() {
      history.push(`/onboarding/lar_db/${id}/auction`);
    }

    function messageBroker() {
      dispatch({
        type: 'CHAT_STATE',
        payload: {
          lar_id: +id,
          recipient_role: 'Broker Loan Manager',
          type: 'sidebar',
        },
      });
    }

    return [
      ...(/auction|scenario/i.test(type) && /Pre Auction|PLA Review/i.test(status)
        ? [
            {
              key: 'verify',
              label: <div onClick={handleVerifyDeal}>Approve for Launch</div>,
            },
          ]
        : []),
      ...(/Launch Approved/i.test(status)
        ? [
            {
              key: 'launch-request',
              label: <div onClick={openLaunchDeal}>Launch Request</div>,
            },
          ]
        : []),
      ...(/pre auction|incomplete|PLA Review/i.test(status) && /scenario/i.test(type)
        ? [
            {
              key: 'begin-scenario',
              label: <div onClick={handleToggleBeginScenario}>Begin Scenario</div>,
            },
          ]
        : []),
      ...(/Active|Quote Selection/i.test(status) && /scenario|auction|scenarios/i.test(type)
        ? [
            {
              key: 'extend-deal',
              label: <div onClick={handleArchiveDelay}>Extend 3 days</div>,
            },
          ]
        : []),
      ...(!/incomplete|draft/i.test(status)
        ? [
            {
              key: 'settings',
              label: <div onClick={openSettings}>Settings</div>,
            },
          ]
        : []),
      ...(/Pending Review/i.test(status)
        ? [
            {
              key: 'approve',
              label: <div onClick={toggleIsApproveDealOpen}>Send for Review</div>,
            },
          ]
        : []),
      ...(!/incomplete|draft/i.test(status)
        ? [
            {
              key: 'profile',
              label: <div onClick={openProfile}>Profile</div>,
            },
          ]
        : []),
      ...(/pre auction|active|PLA Review|/i.test(status)
        ? [
            {
              key: 'archive',
              label: <div onClick={archive}>Archive</div>,
            },
          ]
        : []),
      ...(/archive/i.test(status)
        ? [
            {
              key: 'restore',
              label: <div onClick={unarchive}>Restore</div>,
            },
          ]
        : []),
      ...(/winner selected/i.test(status)
        ? [
            {
              key: 'view-quote',
              label: <div onClick={viewQuote}>View quote</div>,
            },
          ]
        : []),
      ...(/loan processing/i.test(status)
        ? [
            {
              key: 'withdraw',
              label: <div onClick={withdraw}>Withdraw</div>,
            },
          ]
        : []),
      {
        key: 'open-chat',
        label: <div onClick={messageBroker}>Message broker</div>,
      },
    ];
  }, [status, history, id, type, dispatch]);

  return (
    <div className={styles.actions} onClick={(e) => e.stopPropagation()}>
      <Dropdown menu={{ items: menuItems }}>
        <HorizontalDotsIcon />
      </Dropdown>
      <WithdrawModal
        onCancel={() => setArchiveModalVisible(false)}
        onOk={handleArchive}
        visible={archiveModalVisible}
      />
      <WithdrawModal
        withdraw
        onCancel={() => setWithdrawModalVisible(false)}
        onOk={handleWithdraw}
        visible={withdrawModalVisible}
      />
      <Modal
        okText="Confirm"
        title="Are you sure you want to restore this deal?"
        onOk={handleUnarchive}
        open={unarchiveModalVisible}
        onCancel={() => setUnarchiveModalVisible(false)}
      >
        <Typography.Paragraph>
          Restored deals will be added to the Pending pipeline table where you can review, edit, and select to resubmit
          as a scenario or auction.
        </Typography.Paragraph>
        <Typography.Paragraph>
          Note that all activity and messages will be erased from the deal when it is restored. Only information from
          the loan request form will be retained.
        </Typography.Paragraph>
      </Modal>
      <Modal
        okText="Confirm"
        title="Begin scenario"
        onOk={handleBeginScenario}
        open={isBeginScenarioOpen}
        onCancel={handleToggleBeginScenario}
      >
        <Typography.Paragraph>Confirm this information is correct and begin the scenario process</Typography.Paragraph>
      </Modal>
      <AgreementReviewModal
        larId={id}
        open={isApproveDealOpen}
        onOk={handleApprove}
        onCancel={toggleIsApproveDealOpen}
      />
      <DelayArchivePopup
        id={id}
        isOpen={isArchiveDelayOpen}
        onSubmit={handleArchiveDelay}
        onCancel={toggleIsArchiveDelayOpen}
      />
      <LaunchDealModal
        id={id}
        onCancel={handleToggleLaunchDeal}
        isOpen={launchDealModalVisible}
        onOk={handleEndCreation}
      />
      {/Launch Approved/i.test(status) && (
        <ReadyLaunchModal
          onCancel={handleToggleReadyLaunch}
          isOpen={readyLaunchModalVisible}
          onOk={handleEndCreation}
        />
      )}
      {/Launch Approved/i.test(status) && (
        <ReadyLaunchDealModal
          isOpen={readyLaunchDealModalVisible}
          onCancel={handleToggleReadyLaunchDeal}
          onOk={() => postEndCreation('scenario')}
        />
      )}
      <Modal
        okText="Revise"
        title="Begin scenario"
        open={isBeginScenarioFailed}
        onCancel={toggleIsBeginScenarioFailed}
        onOk={() => history.push(`/lar_app/create?lar_id=${id}`)}
      >
        <NoResults />
      </Modal>
    </div>
  );
}
